import { CalendarEvent } from "react-bootstrap-icons";

// Attribution line for the detail modals in the shared "team view": whose calendar this item is on.
// Styled to match the modal's other metadata rows (icon + text) rather than a coloured tag — the
// colour key lives in the grid legend, not here. Only shown for someone else's calendar; your own
// items need no attribution, so it renders nothing for yourself. Write actions are hidden on these
// modals rather than flagged, so no "read only" note is needed.
const OwnerBadge = ({ owner }) => {
  if (!owner || owner.isYou) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-zinc-600">
      <CalendarEvent className="size-4 shrink-0 text-zinc-400" />
      <span>{owner.name}&rsquo;s calendar</span>
    </div>
  );
};

export default OwnerBadge;
